import React, { Component } from "react";
import IconButton from "theme/components/atoms/Button/IconButton";
import { injectIntl, defineMessages } from "react-intl";

const messages = defineMessages({
  close: {
    id: "components.organisms.Modal.CloseModal.close",
    defaultMessage: "Close",
  },
});

class CloseModal extends Component {
  render() {
    return (
      <div className={"modal__close"}>
        <IconButton
          iconType="svg"
          icon="close"
          appearance="square-fade"
          onClick={this.props.onClick}
          title={this.props.intl.formatMessage(messages.close)}
        />
      </div>
    );
  }
}

export default injectIntl(CloseModal);
